import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { resolveValue } from "src/pageDefinitions/values";
import { trackEvent } from "src/utils/api/tracker";
import { logDebug } from "src/utils/monitoring/logging";
import { isCheckoutTimerExpired } from "src/utils/checkoutTimer";
import { ActionHandler, ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";
import { seedCurrentAnswers } from "src/utils/redux/slices/currentAnswers";

type StartSurveyParams = {
  eventName?: string;
};

export const onStartSurvey: ActionHandler = ({
  pageSet,
  page,
  store,
  params = {},
}: {
  params?: StartSurveyParams;
} & ActionHandlerParams) => {
  const survey = getPageSetSurvey(pageSet, page);
  const eventName = params.eventName || `Started${survey.name}`;
  trackEvent(eventName);
  const { surveyNameSpace } = survey;

  logDebug(`Loading survey answers from ${surveyNameSpace}`);
  const lookupValue = resolveValue(surveyNameSpace, store.getState()) || {};
  if (
    surveyNameSpace !== "userData.purchaseSurveyAnswers" ||
    !isCheckoutTimerExpired(store.getState().userData)
  ) {
    store.dispatch(addSurveyAnswers(lookupValue));
    // Merge answers from user data with those stored locally, giving precedence to the
    // local responses.
    store.dispatch(
      seedCurrentAnswers({
        namespace: surveyNameSpace,
        answers: lookupValue,
      })
    );
  }
};
